var _rect, _rect2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyPlayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "black",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 65,
    height: 65,
    rx: 32.5,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8333 46.0846H36.5833V50.8346H31.8333V46.0846ZM35 19.168C43.4708 19.5163 47.16 28.0663 42.125 34.4788C40.8108 36.0621 38.6892 37.1071 37.6442 38.4371C36.5833 39.7513 36.5833 41.3346 36.5833 42.918H31.8333C31.8333 40.2738 31.8333 38.0413 32.8942 36.458C33.9392 34.8746 36.0608 33.9405 37.375 32.8955C41.2067 29.3488 40.2567 24.3296 35 23.918C33.7402 23.918 32.532 24.4184 31.6412 25.3092C30.7504 26.2 30.25 27.4082 30.25 28.668H25.5C25.5 26.1484 26.5009 23.7321 28.2825 21.9505C30.0641 20.1689 32.4804 19.168 35 19.168Z",
    fill: "black",
    fillOpacity: 0.15
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPlayer);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iNzAiIHZpZXdCb3g9IjAgMCA3MCA3MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjcwIiBoZWlnaHQ9IjcwIiByeD0iMzUiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMTUiLz4KPHJlY3QgeD0iMi41IiB5PSIyLjUiIHdpZHRoPSI2NSIgaGVpZ2h0PSI2NSIgcng9IjMyLjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS1vcGFjaXR5PSIwLjEiIHN0cm9rZS13aWR0aD0iNSIvPgo8cGF0aCBkPSJNMzEuODMzMyA0Ni4wODQ2SDM2LjU4MzNWNTAuODM0NkgzMS44MzMzVjQ2LjA4NDZaTTM1IDE5LjE2OEM0My40NzA4IDE5LjUxNjMgNDcuMTYgMjguMDY2MyA0Mi4xMjUgMzQuNDc4OEM0MC44MTA4IDM2LjA2MjEgMzguNjg5MiAzNy4xMDcxIDM3LjY0NDIgMzguNDM3MUMzNi41ODMzIDM5Ljc1MTMgMzYuNTgzMyA0MS4zMzQ2IDM2LjU4MzMgNDIuOTE4SDMxLjgzMzNDMzEuODMzMyA0MC4yNzM4IDMxLjgzMzMgMzguMDQxMyAzMi44OTQyIDM2LjQ1OEMzMy45MzkyIDM0Ljg3NDYgMzYuMDYwOCAzMy45NDA1IDM3LjM3NSAzMi44OTU1QzQxLjIwNjcgMjkuMzQ4OCA0MC4yNTY3IDI0LjMyOTYgMzUgMjMuOTE4QzMzLjc0MDIgMjMuOTE4IDMyLjUzMiAyNC40MTg0IDMxLjY0MTIgMjUuMzA5MkMzMC43NTA0IDI2LjIgMzAuMjUgMjcuNDA4MiAzMC4yNSAyOC42NjhIMjUuNUMyNS41IDI2LjE0ODQgMjYuNTAwOSAyMy43MzIxIDI4LjI4MjUgMjEuOTUwNUMzMC4wNjQxIDIwLjE2ODkgMzIuNDgwNCAxOS4xNjggMzUgMTkuMTY4WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC4xNSIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };